import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    homePrj: 0,
    Prj: '',
    About: false
  },
  mutations: {
    // forwardPrj(state) {
    //   state.homePrj++
    // },
    forwardPrj(state, n) {
      state.homePrj+=n
    },
    // backwardPrj(state) {
    //   state.homePrj--
    // },
    backwardPrj(state,n) {
      state.homePrj-=n
    },
    pushPrj(state, prj) {
      state.Prj = prj
    },
    choosePrj(state, n) {
      state.homePrj = n
    },
    toggleAbout(state){
      state.About = !state.About
      state.homePrj = 0
    }
  },
  actions: {},
  modules: {},
});